import Hero from "../components/Hero";
import Seo from "../components/Seo";
import TrustStrip from "../components/TrustStrip";
import Configurator from "../components/Configurator";
import HowItWorks from "../components/HowItWorks";
import WorkGallery from "../components/WorkGallery";
import BeforeAfter from "../components/BeforeAfter";
import Reviews from "../components/Reviews";
import FAQ from "../components/FAQ";
import FinalCTA from "../components/FinalCTA";

export default function Home() {
  return (
    <div data-testid="home-page">
      <Seo title="Fönsterputs & utvändig rengöring i Skaraborg – Se Klart Ut" path="/" />
      <Hero />
      <TrustStrip />
      <Configurator />
      <HowItWorks />
      <WorkGallery />
      <BeforeAfter />
      <Reviews />
      <FAQ />
      <FinalCTA />
    </div>
  );
}
